import {
  SupportPartnerKeySchema,
  SupportPartnershipInputSchema,
  SupportPartnershipSchema,
} from "@redotech/redo-support-partnerships-common/support-partnership";
import * as z from "zod";

export const updateSupportPartnership = {
  name: "updateSupportPartnership" as const,
  input: z.object({
    partnerKey: SupportPartnerKeySchema,
    partnership: SupportPartnershipInputSchema,
  }),
  output: z.object({ partnership: SupportPartnershipSchema }),
};
